import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "512",
      height: "512",
      fill: "#3178c6",
      rx: "50"
    }, null, -1),
    _createElementVNode("rect", {
      width: "512",
      height: "512",
      fill: "#3178c6",
      rx: "50"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M316.939 407.424v50.061q12.207 6.258 28.875 9.386c16.668 3.128 22.823 3.129 35.135 3.129q17.998 0 34.196-3.442 16.199-3.441 28.406-11.342 12.207-7.9 19.328-20.65C470 421.816 470 415.559 470 403.044q0-13.61-4.069-23.857c-4.069-10.247-6.625-12.906-11.738-18.225q-7.668-7.979-18.389-14.315c-10.721-6.336-15.207-8.213-24.18-11.967q-9.86-4.068-17.685-7.9-7.825-3.834-13.303-7.822-5.478-3.99-8.451-8.448t-2.974-10.091q0-5.162 2.661-9.308c2.661-4.146 4.278-5.136 7.512-7.118q4.852-2.972 11.894-4.615 7.043-1.642 15.651-1.642 6.26 0 13.224.938 6.964.94 14.008 2.894a97.5 97.5 0 0 1 13.694 4.928q6.651 2.973 12.285 6.884v-46.776q-11.424-4.38-24.962-6.492C421.64 238 415.797 238 404.112 238q-17.842 0-33.805 3.833c-15.963 3.833-20.006 6.544-28.093 11.967q-12.129 8.136-19.171 20.729Q316 287.122 316 304.643q0 22.371 12.912 38.172 12.91 15.8 39.204 26.751 10.33 4.224 19.25 8.291c8.92 4.067 11.086 5.528 15.415 8.448q6.495 4.38 10.252 9.543 3.756 5.161 3.756 11.733 0 4.85-2.348 8.995c-2.348 4.145-3.939 5.162-7.121 7.196s-7.147 3.624-11.894 4.771q-7.121 1.721-16.668 1.721-16.276 0-32.24-5.71-15.963-5.709-29.579-17.13M232.78 284.082H297V243H118v41.082h63.906V467h50.874z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }